import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Text } from 'grommet';
import PropTypes from 'prop-types';
import userAPI from 'granite-admin/accounts/gateways/user-api';
const Alert = ({
  closeBtnLabel,
  onClose,
  id,
  link,
  message,
  showCloseBtn,
  type,
  email,
  phone
}) => {
  const mapTypeToColor = type => {
    let color = 'status-warning';
    switch (type) {
      case 'warning':
        color = 'status-warning';
        break;
      case 'info':
        color = 'neutral-3';
        break;
      case 'success':
        color = 'status-ok';
        break;
      case 'danger':
        color = 'status-error';
        break;
      case 'secondary':
        color = 'status-unknown';
        break;
      default:
        break;
    }
    return color;
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    pad: "xsmall",
    justify: "center",
    background: {
      color: mapTypeToColor(type),
      opacity: '0.5'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: link
  }, /*#__PURE__*/React.createElement(Box, {
    flex: {
      grow: 1
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    size: "alert",
    onClick: () => userAPI.resendOtp({
      email,
      phone
    })
  }, message))), showCloseBtn && /*#__PURE__*/React.createElement(Button, {
    color: "light-1",
    label: closeBtnLabel,
    onClose: () => onClose(id),
    plain: true
  }));
};
Alert.defaultProps = {
  closeBtnLabel: 'X',
  showCloseBtn: true,
  link: '#',
  type: 'danger'
};
Alert.propTypes = {
  closeBtnLabel: PropTypes.string,
  showCloseBtn: PropTypes.bool,
  link: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  id: PropTypes.any,
  email: PropTypes.string,
  phone: PropTypes.string,
  type: PropTypes.oneOf(['warning', 'info', 'success', 'danger', 'secondary'])
};
export default Alert;